(ns
  frontend.ui.component.lp-portal.report.body.private-equity.pdf.view.investors
  (:require
   [frontend.ui.component.lp-portal.table.pdf.view :refer [dynamic-table]]
   [frontend.ui.component.lp-portal.table.pdf.view :as table]
   [frontend.ui.style.theme.core :as theme]))

(defn investors-pages
  [report-data]
  (table/dynamic-table-pages
   {:fund-name (:fund-name report-data) :page-title "Investors" :toc-item true}
   "Investors, €"
   (-> report-data
       :investors)
   {:full-width?    true
    :partition-size 25
    :odd-color      (theme/color [:pdf :table :odd-color])
    :even-color     (theme/color [:pdf :table :even-color])
    :heading-color  (theme/color [:pdf :table :heading-color])}))
